import React, {useEffect, useMemo, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchGraphThree } from '../../redux/actions'
import {Bar} from 'react-chartjs-2'
import {useTranslation} from "react-i18next";
import i18n from "i18next";

const GraphThree = ({settings}) => {

    const {t} = useTranslation()
    const dispatch = useDispatch()
    const [currentPeriod, setCurrentPeriod] = useState('')
    const graphThreeData = useSelector(state => state.analytics.statistics_for_all_period)
    const [period, setPeriod] = useState({
        start: '',
        end: ''
    })
    const [graphData, setGraphData] = useState([])

    const dates = ['1 week', '1 month', '3 months', '6 months', '1 year']

    useEffect(() => {
        let requestingUrl = `https://rezilizer.ru/api/analytics/orders/?days=${30}`
        dispatch(fetchGraphThree(requestingUrl))
        setMinDates()
    }, [])

    useEffect(() => {
        try {
            const fillArray = []
            graphThreeData.profitForDay.map(dateObj => {
                for (let keyName in dateObj) {
                    fillArray.push(dateObj[keyName])
                }
            })
            setGraphData(fillArray)
        } catch (e) {}
    }, [graphThreeData])

    function setDateTime(event) {
        setPeriod({
            ...period, [event.target.name] : event.target.value
        })
        setCurrentPeriod('')
    }

    function showGraph() {
        const inputsStartDate = JSON.stringify(period.start)
        const inputsEndDate = JSON.stringify(period.end)
        if (inputsStartDate === '""' && inputsEndDate === '""') {
            let days = 7
            // for selected
            if (currentPeriod === '1 month') {
                days = 30
            } else if (currentPeriod === '3 months') {
                days = 92
            } else if (currentPeriod === '6 months') {
                days = 183
            } else if (currentPeriod === '1 year') {
                days = 365
            } else if (currentPeriod === '1 week') {
                days = 7
            }
            let requestingUrl = `https://rezilizer.ru/api/analytics/orders/?days=${days}`
            dispatch(fetchGraphThree(requestingUrl))
        } else {
            let requestingUrl = `https://rezilizer.ru/api/analytics/orders/?start=${period.start}&end=${period.end}`
            dispatch(fetchGraphThree(requestingUrl))
        }
    }

    function setMinDates() {
        const today = new Date()
        let dd = today.getDate();
        let mm = today.getMonth() + 1; //January is 0!
        let yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }

        let currentDay = `${yyyy}-${mm}-${dd-2}`
        let nextDay = `${yyyy}-${mm}-${dd-1}`

        const minStartDate = document.querySelector('#start')
        const minEndDate = document.querySelector('#end')

        minStartDate.setAttribute('max', currentDay)
        minEndDate.setAttribute('max', nextDay)
    }

    function toggleDatesPanel() {
        const datesPanel = document.querySelector('.extra-periods')
        datesPanel.classList.toggle('visible')
    }

    function selectDate(date) {
        // clear input dates
        const date1 = document.querySelectorAll("input[type=date]")
        const graph = document.querySelector('.graph.three')
        date1[0].value = ""
        date1[1].value = ""
        setPeriod({start: '', end: ''})
        if (currentPeriod === date) {
            toggleDatesPanel()
        } else {
            setCurrentPeriod(date)
            toggleDatesPanel()
        }
    }

    // Memorizing graph because time period change causes re-render
    const Three = useMemo(() => {
        return (
            <Bar className="graph three"
                  data={{
                      labels: graphThreeData.date,
                      datasets: [
                          {
                              label: 'Profit from car',
                              data: graphData.map(item => {
                                  return item.profit
                              }),
                              backgroundColor: 'royalblue',
                              tension: 0.4,
                              fill: true
                          }
                      ]
                  }}
                  options={
                      {
                          scales: {
                              yAxes: {
                                  beginAtZero: true
                              }
                          },
                          ...settings,
                          maintainAspectRatio: true
                      }}
            />
        )
    }, [graphThreeData, graphData])

    return (
        <>
            <div className="chart-info">
                <h2>{t('graphThreeTitle')}</h2>
                <p className="descr three">{t('graphThreeDescription')}</p>
                <div className="chart-info-extra three">
                    {
                        (() => {
                            if (i18n.language === 'uz') {
                                return (
                                    <>
                                        <div className="form-control">
                                            <input type="date" name='start' id="start" onChange={setDateTime}/>
                                            <label htmlFor="start">{t('carSelectionFrom')}</label>
                                        </div>
                                        <div className="form-control">
                                            <input type="date" name='end' id="end" onChange={setDateTime}/>
                                            <label htmlFor="end">{t('carSelectionTo')}</label>
                                        </div>
                                    </>
                                )
                            } else {
                                return (
                                    <>
                                        <div className="form-control">
                                            <label htmlFor="start">{t('from')}: </label>
                                            <input type="date" name='start' id="start" onChange={setDateTime}/>
                                        </div>
                                        <div className="form-control">
                                            <label htmlFor="end">{t('carSelectionTo')}: </label>
                                            <input type="date" name='end' id="end" onChange={setDateTime}/>
                                        </div>
                                    </>
                                )
                            }
                        }) ()
                    }
                    <div className="periods">
                        <div className="selected-period" onClick={() => selectDate(`${currentPeriod}`)}>{
                            (() => {
                                if (currentPeriod === '') {
                                    return 'Select period'
                                } else {
                                    return currentPeriod
                                }
                            }) ()
                        }</div>
                        <div className="extra-periods">
                            {
                                dates
                                    .filter(date => date !== currentPeriod)
                                    .map((date, index) => {
                                        return (
                                            <span onClick={() => selectDate(`${date}`)} key={index}>{date}</span>
                                        )
                                    })
                            }
                        </div>
                    </div>
                    <button onClick={showGraph}>{t('buildTheGraph')}</button>
                </div>
            </div>
            {Three}
        </>
    )
}

export default React.memo(GraphThree);
